const UploadIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask
        id="mask0_9862_86899"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_9862_86899)">
        <path
          d="M10.0007 13.3333C9.76454 13.3333 9.56676 13.2533 9.40732 13.0933C9.24732 12.9339 9.16732 12.7361 9.16732 12.5V6.54167L7.60482 8.10417C7.43815 8.27083 7.24371 8.35417 7.02148 8.35417C6.79926 8.35417 6.59787 8.26389 6.41732 8.08333C6.25065 7.91667 6.17093 7.71861 6.17815 7.48917C6.18482 7.26028 6.26454 7.06944 6.41732 6.91667L9.41732 3.91667C9.50065 3.83333 9.59093 3.77417 9.68815 3.73917C9.78537 3.70472 9.88954 3.6875 10.0007 3.6875C10.1118 3.6875 10.2159 3.70472 10.3132 3.73917C10.4104 3.77417 10.5007 3.83333 10.584 3.91667L13.584 6.91667C13.7507 7.08333 13.8304 7.28111 13.8232 7.51C13.8165 7.73944 13.7368 7.93056 13.584 8.08333C13.4173 8.25 13.2195 8.33667 12.9907 8.34333C12.7612 8.35056 12.5632 8.27083 12.3965 8.10417L10.834 6.54167V12.5C10.834 12.7361 10.7543 12.9339 10.5948 13.0933C10.4348 13.2533 10.2368 13.3333 10.0007 13.3333ZM5.00065 16.6667C4.54232 16.6667 4.1501 16.5036 3.82398 16.1775C3.49732 15.8508 3.33398 15.4583 3.33398 15V13.3333C3.33398 13.0972 3.41371 12.8992 3.57315 12.7392C3.73315 12.5797 3.93121 12.5 4.16732 12.5C4.40343 12.5 4.60148 12.5797 4.76148 12.7392C4.92093 12.8992 5.00065 13.0972 5.00065 13.3333V15H15.0007V13.3333C15.0007 13.0972 15.0807 12.8992 15.2407 12.7392C15.4001 12.5797 15.5979 12.5 15.834 12.5C16.0701 12.5 16.2679 12.5797 16.4273 12.7392C16.5873 12.8992 16.6673 13.0972 16.6673 13.3333V15C16.6673 15.4583 16.5043 15.8508 16.1782 16.1775C15.8515 16.5036 15.459 16.6667 15.0007 16.6667H5.00065Z"
          fill="#0276FE"
        />
      </g>
    </svg>
  );
};

export default UploadIcon;
